module.exports = __webpack_public_path__ + "img/34_40.682af6b4.png";